class FiskalyAtController extends AbstractIntegrationController
	@register()
	@inject 'translate',
		'configuration'
		'configurationOptions'
		'IntegrationRepository'
		'ToastService'
		'BACKEND_FISKALY_AT_LEGAL_ENTITY_ID_TYPE'

	integrationId: 'fiskaly_at'

	initialize: ->
		@isNew = @configuration.is_active != true

		@legalEntityTypeIdTypes = _.map @BACKEND_FISKALY_AT_LEGAL_ENTITY_ID_TYPE, (type) =>
			id: type
			name: @translate('wbo.integration.fiskaly_at.legal_entity_id_type.' + type)

	afterDisconnect: ->
		@configuration = {}

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data

	afterDisconnect: ->
		@configuration = {}
